import { createPortal } from 'react-dom';
import { useEffect, useState } from 'react';
import css from './index.module.scss';
import IoMdCloseCircle from '@/components/UI/svg/Icons/IoMdCloseCircle';
import { useGlobal } from '@/utils/useGlobal';
import Aliplayer from '@/components/UI/Aliplayer';

type params = {
    floatVideo: boolean;
    setFloatVideo?: (floatVideo: boolean) => void;
    handleClose?: () => void;
    videoSrc: string;
    playerParams?: {
        iframeWidth?: number;
        iframeHeight?: number;
    };
    type?: 'YouTube' | 'Native';
};

const defaultConfig = {
    iframeWidth: 840,
    iframeHeight: 472,
};

export default function YouTubeVideoPlayer({ floatVideo, setFloatVideo, videoSrc, playerParams, handleClose, type = 'YouTube' }: params) {
    const config = { ...defaultConfig, playerParams };
    const { useLang } = useGlobal();
    const { t } = useLang('shared');
    const [isClient, setIsClient] = useState<boolean>(false);

    const closerVideo = () => {
        handleClose && handleClose();
        setFloatVideo && setFloatVideo(false);
    };

    useEffect(() => {
        setIsClient(true);
    }, []);

    useEffect(() => {
        document.documentElement.style.overflowY = floatVideo ? 'hidden' : '';
        return () => {
            document.documentElement.style.overflowY = '';
        };
    }, [floatVideo]);

    return (
        <>
            {isClient &&
                createPortal(
                    <div className={css.youTubeVideoPlayer}>
                        {floatVideo && (
                            <div className="youtubeVideo">
                                <IoMdCloseCircle className="closeIcon" onClick={closerVideo} />
                                {/* YouTube */}
                                {type === 'YouTube' && (
                                    <iframe
                                        width={config.iframeWidth}
                                        height={config.iframeHeight}
                                        src={videoSrc}
                                        title={t('youtube_video_player')}
                                        frameBorder="0"
                                        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; autoplay"
                                    />
                                )}

                                {/* Native Video */}
                                {type === 'Native' && (
                                    // <video
                                    //     className="video-raw"
                                    //     width={config.iframeWidth}
                                    //     height={config.iframeHeight}
                                    //     autoPlay={true}
                                    //     src={videoSrc}
                                    //     controls
                                    // ></video>
                                    <Aliplayer
                                        className="video-ali"
                                        source={videoSrc}
                                        width={`${config.iframeWidth}px`}
                                        height={`${config.iframeHeight}px`}
                                        autoplay={true}
                                    />
                                )}
                            </div>
                        )}
                    </div>,
                    document.body,
                )}
        </>
    );
}
